import { render, staticRenderFns } from "./UiCard.vue?vue&type=template&id=53ec5310&scoped=true"
import script from "./UiCard.vue?vue&type=script&lang=js"
export * from "./UiCard.vue?vue&type=script&lang=js"
import style0 from "./UiCard.vue?vue&type=style&index=0&id=53ec5310&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ec5310",
  null
  
)

export default component.exports